import { SalesPeriod } from "./salesOverviewService";
import type { LifecycleLabels } from "../../../../utils/lifecycleUtils";
import { ENTITY_ICONS } from "../entityIcons";

export const palette = {
  primary: "#E41F07",
  secondary: "#FFA201",
  axis: "#6F6F6F",
  grid: "#E0E0E0",
  tillDateBar: "#DDD7F4",
  salesBarLight: "#FFC861",
  dealSize: "#3C2371",
  dealSizeLight: "#C9C2E6",
  dataLabel: "#262A2A",
  won: "#F2A92D",
  lost: "#E43D2A",
  ringTrack: "#E2E8F0",
  gaugeTrack: "#F3F4F6",
  gaugeLabel: "#6B7280",
  needle: "#3F3F46",
};

export type PeriodLabel = "Weekly" | "Monthly" | "Yearly";

export const periodOptions: PeriodLabel[] = ["Weekly", "Monthly", "Yearly"];

export const periodKeys: Record<PeriodLabel, SalesPeriod> = {
  Weekly: "by_week",
  Monthly: "by_month",
  Yearly: "by_year",
};

export type StatTone = "primary" | "success" | "info" | "warning";

export type StatFormat = "currency" | "number";

export interface StatMeta {
  icon: string;
  currencyIcon?: "coin" | "filter";
  tone: StatTone;
  format: StatFormat;
  label?: (names: LifecycleLabels) => string;
  showAmount?: boolean;
}

export const overviewStatMeta: Record<string, StatMeta> = {
  total_sales_in_current_period: {
    icon: "ti ti-chart-bar",
    currencyIcon: "filter",
    tone: "info",
    format: "currency",
    label: () => "Total Sales",
  },
  total_revenue_in_current_period: {
    icon: "ti ti-coin",
    currencyIcon: "coin",
    tone: "success",
    format: "currency",
    label: () => "Total Revenue",
  },
  total_lead_in_current_period: {
    icon: ENTITY_ICONS.lead,
    tone: "warning",
    format: "number",
    label: (names) => `Total ${names.leads}`,
    showAmount: true,
  },
  total_pipeline_in_current_period: {
    icon: ENTITY_ICONS.pipeline,
    tone: "primary",
    format: "number",
    label: (names) => `Total ${names.pipelines}`,
    showAmount: true,
  },
  total_activities_in_current_period: {
    icon: "ti ti-bolt",
    tone: "info",
    format: "number",
    label: () => "Total Activities",
  },
};

export const defaultStatMeta: StatMeta = {
  icon: "ti ti-chart-dots",
  tone: "primary",
  format: "number",
};

export const SALES_TREND_POINTS = 12;

export const companyLogos = [
  "assets/img/icons/company-icon-06.svg",
  "assets/img/icons/company-icon-07.svg",
  "assets/img/icons/company-icon-02.svg",
  "assets/img/icons/company-icon-03.svg",
  "assets/img/icons/company-icon-08.svg",
];

export const stageClassNames = ["bg-purple-subtle", "bg-success-subtle", "bg-warning-subtle", "bg-danger-subtle"];

export const GAUGE_SEGMENTS = 25;
